export default "__VITE_ASSET__B4OtDg6L__"